import * as React from "react";
import type { SVGProps } from "react";
const SvgVilla = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21 11h-7V3s-.01-.04-.01-.07c0-.07-.02-.13-.04-.2s-.04-.13-.07-.19c-.01-.02-.01-.04-.02-.06-.02-.03-.05-.05-.08-.09a.5.5 0 0 0-.14-.15c-.05-.04-.1-.07-.16-.11-.06-.03-.11-.06-.17-.08-.07-.02-.13-.03-.2-.04-.04 0-.07-.02-.11-.02-.02 0-.04.01-.07.01-.07 0-.13.02-.19.04-.07.02-.13.04-.19.07-.02.01-.04.01-.06.02l-10 6.01c-.3.18-.49.51-.49.86v12c0 .55.45 1 1 1h18c.55 0 1-.45 1-1v-9c0-.55-.45-1-1-1m-9-6.23V11H8c-.55 0-1 .45-1 1v8H4V9.57zM14 20v-2h1v2zm6 0h-3v-3c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v3H9v-7h11z"
    />
  </svg>
);
export default SvgVilla;
